var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{},[_c('td',{staticClass:"pr-2 py-2"},[_vm._v(_vm._s(_vm.investment.entity_name))]),_c('td',{staticClass:"pl-2 py-2"},[_vm._v(_vm._s(_vm.investment.investment_name))]),_c('td',{staticClass:"pl-2 py-2"},[_vm._v(_vm._s(_vm.investment.investment_status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }